import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-card';
const cardInfoUrl = '/gateway/wombat-mgt/api/vs/card-info';

const depositActivities = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/card-activities`, data);
};

// 后台手工调整储值（调入 / 调出），走 card-info 的资金变动接口
const adjustMemberDeposit = (merchantId, customerId, data) => {
	return Client.post(
		`${cardInfoUrl}/${merchantId}/fund-activities/${customerId}`,
		data
	);
};

const depositActivitiesExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/card-activities/export`, data, {
		responseType: 'blob',
	});
};

const depositBalance = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/cards`, data);
};

const rechargeStrategies = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/recharge-strategies`, data);
};

const updateRechargeStrategies = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/recharge-strategies`, data);
};

const deleteRechargeStrategies = (merchantId, strategyId) => {
	return Client.del(
		`${baseUrl}/${merchantId}/recharge-strategies/${strategyId}`
	);
};

export default {
	depositActivities,
	depositActivitiesExport,
	adjustMemberDeposit,
	depositBalance,
	rechargeStrategies,
	updateRechargeStrategies,
	deleteRechargeStrategies,
};
